import { Button, Card, Col, Form, Row, Select, Switch, Typography } from "antd";
import { staticConfig } from "../../treasury.config";
import { InfoCircleOutlined } from "@ant-design/icons";
import ChevronDown from "@untitled-ui/icons-react/build/esm/ChevronDown";
import React from "react";
import SectionCard from "./SectionCard";

const { Text, Link, Title, Paragraph } = Typography;

export default function MaturitySettings({
  setData,
  data,
  activePage,
  setActivePage,
  setHasModified,
  hasModifed,
  template,
}) {
  const [form] = Form.useForm();
  const allowRollover = Form.useWatch("allowRollover", form);
  const autoRollover = Form.useWatch("autoRollover", form);

  function onFinish(_data) {
    setData({ ...data, ..._data });
    setActivePage(activePage + 1);
  }
  function onFinishFailed() {}
  function goBack() {
    setActivePage(activePage - 1);
  }
  function handleValuesChange() {
    setHasModified && setHasModified([...hasModifed, activePage]);
  }
  React.useEffect(() => {
    form.setFieldsValue(data);
  }, [data]);

  return (
    <SectionCard onPrev={goBack} onNext={form.submit} nextTitle={" Next - Tax & Charges"}>
      <Form
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        style={{ paddingTop: 0 }}
        onValuesChange={handleValuesChange}
      >
        <Title style={{ margin: 0, marginBottom: 5 }} level={3}>
          Maturity Settings
        </Title>

        <Row style={{ marginTop: 20 }} gutter={16}>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item
              style={{ marginTop: 20 }}
              name="debitSourceAccountType"
              rules={[
                {
                  required: true,
                  message: "Please select debit source account",
                },
              ]}
              label={
                <Text style={{ color: "#344054" }}>
                  Debit Source Account <InfoCircleOutlined color="#667085" />
                </Text>
              }
            >
              <Select
                className="custom-input"
                // size="large"
                options={template?.debitSourceAccountTypeOptions}
                placeholder={"Select debit source account"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              style={{ marginTop: 20 }}
              label={
                <Text style={{ color: "#344054" }}>
                  Settlement Date <InfoCircleOutlined color="#667085" />
                </Text>
              }
              name="settlementDate"
              rules={[
                {
                  required: true,
                  message: "Please select settlement date",
                },
              ]}
            >
              <Select
                className="custom-input"
                // size="large"
                options={template?.settlementDateTypes}
                placeholder={"Select settlement date"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            {" "}
            <Form.Item
              style={{}}
              label={
                <Text style={{ color: "#344054" }}>
                  Maturity Proceeds <InfoCircleOutlined color="#667085" />
                </Text>
              }
              name="maturityProceed"
              rules={[
                {
                  required: true,
                  message: "Please select maturity proceeds",
                },
              ]}
            >
              <Select
                className="custom-input"
                // size="large"
                options={template?.maturityProceeds}
                // options={template?.maturityProceeds}
                placeholder={"Select maturity proceeds"}
                suffixIcon={<ChevronDown color="#667085" width={20} />}
              />
            </Form.Item>
          </Col>

          <Col
            span={6}
            style={{
              padding: "0px 8px",
              marginTop: 35,
              display: "flex",
              gap: 10,
              // alignItems: "center",
            }}
          >
            {" "}
            <Form.Item
              name={"allowRollover"}
              style={{ margin: 0, padding: 0 }}
              valuePropName="checked"
            >
              <Switch className="custom-switch" />
            </Form.Item>
            {/* </Col> */}
            {/* <Col span={8} style={{ padding: "0px 8px" }}> */}
            <Text style={{ margin: 0, color: "#667085", marginTop: 5 }}>Rollover option</Text>
          </Col>
          {allowRollover && (
            <Col span={6} style={{ padding: "0px 8px", marginTop: 28 }}>
              <Form.Item
                style={{ margin: 0, padding: 0, width: "100%" }}
                name="autoRollover"
                rules={[
                  {
                    required: true,
                    message: "Please select rollover option",
                  },
                ]}
              >
                <Select
                  style={{
                    margin: 0,
                    padding: 0,
                    width: "100%",
                    height: "44px",
                  }}
                  className="custom-input"
                  // size="large"
                  options={staticConfig.rolloverOption}
                  placeholder={"Select rollover option"}
                  suffixIcon={<ChevronDown color="#667085" width={20} />}
                />
              </Form.Item>
            </Col>
          )}
        </Row>
      </Form>
    </SectionCard>
  );
}
